import React from 'react';

class InstallmentAgreementGuide extends React.Component<{}, {}> {

    constructor(_props: any) {
        super(_props);
    }

    public render() {
        return (
            <div style={{ textAlign: 'left', fontSize: '18px' }}>
                <div>
                    <p><strong>💡 EasAly AI Guide: How to Choose the Right Installment Plan Strategically</strong></p>
                    <p>The installment plan you select affects more than just how much you pay each month. It also determines <strong>how much the total cost will be</strong>, whether the <strong>Internal Revenue Service (IRS)</strong> will file a lien, and how much control the IRS can have over your finances during the repayment period.</p>
                    <p>Here are the most important things to understand when deciding on a plan:</p>
                    <ol>
                        <li><strong> Paying sooner usually costs less overall<br /></strong><br />The faster your tax debt is paid, the less interest and penalty charges the IRS adds.
                            <ul>
                                <li>Short-term repayment options, like the <strong>180-Day Full Pay Hold</strong> or the <strong>Guaranteed Installment Agreement</strong>, typically result in the <strong>lowest total cost</strong>.</li>
                                <li>These work best for people who can afford to pay their balance in a short amount of time.</li>
                            </ul>
                        </li>
                        <li><strong> Longer repayment can increase total cost dramatically<br /><br /></strong>If you choose a plan that spreads payments out over several years&mdash;such as a <strong>Streamlined Installment Agreement</strong>, a <strong>Routine Installment Agreement</strong>, or a <strong>Non-Streamlined Installment Agreement</strong>&mdash;the IRS continues to charge interest and penalties on the unpaid balance.
                            <ul>
                                <li>This means you can end up paying <strong>thousands or even tens of thousands of dollars more</strong> than the original amount you owed.</li>
                                <li>These plans may lower your monthly payment, but they increase what you pay overall.</li>
                            </ul>
                        </li>
                        <li><strong> Partial Payment Installment Agreements can lower the amount you actually pay<br /><br /></strong>A <strong>Partial Payment Installment Agreement</strong> allows you to make monthly payments that may <strong>not fully pay off the debt</strong> before the IRS collection period ends.
                            <ul>
                                <li>In some cases, the IRS forgives the remaining balance at the end of the collection period.</li>
                                <li>This can lower your total out-of-pocket cost.</li>
                                <li>However, these agreements almost always involve a lien, and the IRS can increase your payments if your financial situation improves in the future.</li>
                            </ul>
                        </li>
                        <li><strong> A federal tax lien can affect more than just your tax situation<br /><br /></strong>A <strong>federal tax lien</strong> is the government&rsquo;s legal claim against your property when you do not pay a tax debt.
                            <ul>
                                <li>A lien can affect your credit, your ability to get loans, and your ability to sell or refinance property.</li>
                                <li>Smaller balances and faster repayment reduce the likelihood of a lien.</li>
                                <li>Larger balances almost always result in a lien being filed.</li>
                            </ul>
                        </li>
                        <li><strong> Financial disclosure can influence what plans are available to you<br /><br /></strong>Some installment plans, such as streamlined options, do not require you to provide the IRS with detailed financial information.<br /><br />Others, such as routine installment agreements, partial payment agreements, and non-streamlined agreements, require full financial disclosure.
                            <ul>
                                <li>This means the IRS will review your income, expenses, and assets.</li>
                                <li>If your situation improves, the IRS can require larger payments later.</li>
                            </ul>
                        </li>
                        <li><strong> Staying compliant is essential<br /><br /></strong>Once you have an installment plan, the IRS expects you to <strong>file and pay all future taxes on time</strong>.
                            <ul>
                                <li>If you fall behind on new taxes, the IRS can <strong>cancel your agreement</strong>, add new penalties and interest, and take collection actions such as wage garnishments or bank levies.</li>
                                <li>Remaining current with your taxes protects your agreement and prevents new problems.</li>
                            </ul>
                        </li>
                        <li><strong> EasAly helps you reduce total cost and risk<br /><br /></strong>EasAly&rsquo;s process is designed to help taxpayers find the <strong>most cost-effective and stable plan</strong> for their situation.<br /><br />EasAly helps you:
                            <ul>
                                <li>Minimize the total amount you pay over time</li>
                                <li>Avoid or reduce the chance of a lien when possible</li>
                                <li>Protect yourself from forced collection actions</li>
                                <li>Match your monthly payment to your actual ability to pay</li>
                                <li>Stay on track with compliance to avoid default</li>
                            </ul>
                        </li>
                    </ol>
                    <p>✅ <strong>Bottom Line:</strong></p>
                    <p>💡<strong> Choosing the Right Plan</strong></p>
                    <ul>
                        <li><strong>If your goal is to minimize penalties and interest:</strong>
                            <ul>
                                <li>Choose a plan you can <strong>consistently afford and maintain.</strong></li>
                                <li>Make <strong>extra voluntary payments</strong> whenever possible to reduce the balance faster and limit future interest and penalty accruals.</li>
                            </ul>
                        </li>
                        <li><strong>If your goal is to keep monthly payments low:</strong>
                            <ul>
                                <li>Understand that <strong>lower payments usually mean paying more over time</strong> because interest continues to accrue until the balance is paid in full.</li>
                            </ul>
                        </li>
                        <li><strong>If you cannot pay your balance in full:</strong>
                            <ul>
                                <li>Consider a <strong>Partial Pay Installment Agreement (PPIA)</strong> or <strong>Currently Not Collectible (CNC)</strong></li>
                                <li>While <strong>Partial Pay agreements and CNC</strong> typically include a <strong>federal tax lien</strong>, they may <strong>reduce your total out-of-pocket cost</strong> and, in some cases, result in better outcomes than an Offer in Compromise if the <strong>collection statute (CSED)</strong> is close to expiring.</li>
                                <li>Both <strong>Partial Pay Agreements and CNC</strong><strong> status </strong>pauses active collection but keeps the statute running while you get back on your feet.</li>
                            </ul>
                        </li>
                        <li><strong>No matter which plan you choose:</strong>
                            <ul>
                                <li>Staying <strong>current with all future tax filings and payments</strong> is essential to keep your agreement in good standing and avoid enforcement action</li>
                            </ul>
                        </li>
                    </ul>
                    <p>&nbsp;</p>
                    <table border={1} width="100%" cellSpacing={0} cellPadding={10}>
                        <thead>
                            <tr>
                                <td width="83">
                                    <p><strong>Option</strong></p>
                                </td>
                                <td width="72">
                                    <p><strong>Amount Owed</strong></p>
                                </td>
                                <td width="64">
                                    <p><strong>Financials</strong></p>
                                    <p><strong>Required</strong></p>
                                </td>
                                <td width="82">
                                    <p><strong>Term</strong></p>
                                </td>
                                <td width="86">
                                    <p><strong>Lien</strong></p>
                                </td>
                                <td width="86">
                                    <p><strong>CSED</strong></p>
                                </td>
                                <td width="150">
                                    <p><strong>Best For</strong></p>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td width="83">
                                    <p>Short Term 180-Day Hold</p>
                                </td>
                                <td width="72">
                                    <p>Any (if payable)</p>
                                </td>
                                <td width="64">
                                    <p>❌ No</p>
                                </td>
                                <td width="82">
                                    <p>180 days</p>
                                </td>
                                <td width="86">
                                    <p>❌ No</p>
                                </td>
                                <td width="86">
                                    <p>✅ Continues to run</p>
                                </td>
                                <td width="150">
                                    <p>Temporary cash-flow gaps, quick resolution.</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="83">
                                    <p>Guaranteed (IMF)</p>
                                </td>
                                <td width="72">
                                    <p>&le; $10K</p>
                                </td>
                                <td width="64">
                                    <p>❌ No</p>
                                </td>
                                <td width="82">
                                    <p>Up to 36 months</p>
                                </td>
                                <td width="86">
                                    <p>❌ No</p>
                                </td>
                                <td width="86">
                                    <p>✅ Continues to run</p>
                                </td>
                                <td width="150">
                                    <p>Taxpayers that can afford minimum monthly payment</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="83">
                                    <p>Streamlined 72 Month Direct Debit Installment Agreement</p>
                                </td>
                                <td width="72">
                                    <p>&le; $50K</p>
                                </td>
                                <td width="64">
                                    <p>❌ No</p>
                                </td>
                                <td width="82">
                                    <p>Up to 72 months</p>
                                </td>
                                <td width="86">
                                    <p>⚠️ Sometimes</p>
                                </td>
                                <td width="86">
                                    <p>✅ Continues to run</p>
                                </td>
                                <td width="150">
                                    <p>Taxpayers that can afford minimum monthly payment</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="83">
                                    <p>Partial Payment (PPIA)</p>
                                </td>
                                <td width="72">
                                    <p>Varies</p>
                                </td>
                                <td width="64">
                                    <p>✅ Yes</p>
                                </td>
                                <td width="82">
                                    <p>Periodic Review Every 12-24 months</p>
                                </td>
                                <td width="86">
                                    <p>✅ Yes</p>
                                </td>
                                <td width="86">
                                    <p>✅ Continues to run</p>
                                </td>
                                <td width="150">
                                    <p>Taxpayers that cannot afford minimum payment plan but can afford a reduced monthly payment based on ability to pay. This is preferred when taxpayers have short statutes and equity in assets.</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="83">
                                    <p>Non-Streamline Installment Agreement (NSIA)</p>
                                </td>
                                <td width="72">
                                    <p>&gt; $250K</p>
                                </td>
                                <td width="64">
                                    <p>❌ No</p>
                                </td>
                                <td width="82">
                                    <p>By CSED</p>
                                </td>
                                <td width="86">
                                    <p>✅ Yes</p>
                                </td>
                                <td width="86">
                                    <p>✅ Continues to run</p>
                                </td>
                                <td width="150">
                                    <p>Cases with very large balances who can afford large monthly payments and do not wish to provide a financial disclosure or liquidate assets.</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="83">
                                    <p>Currently Non-Collectible (CNC)</p>
                                </td>
                                <td width="72">
                                    <p>Any Amount</p>
                                </td>
                                <td width="64">
                                    <p>✅ Yes</p>
                                </td>
                                <td width="82">
                                    <p>Periodic Review Every 12-24 months</p>
                                </td>
                                <td width="86">
                                    <p>✅ Yes</p>
                                </td>
                                <td width="86">
                                    <p>✅ Continues to run</p>
                                </td>
                                <td width="150">
                                    <p>Inability to pay monthly/low disposable income and short statute of limitations</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="83">
                                    <p>Offer in Compromise&nbsp; (OIC)</p>
                                </td>
                                <td width="72">
                                    <p>Any Amount</p>
                                </td>
                                <td width="64">
                                    <p>✅ Yes</p>
                                </td>
                                <td width="82">
                                    <p>Typically takes 18-24 months or longer</p>
                                </td>
                                <td width="86">
                                    <p>🟢 Lien released once offer accepted and paid</p>
                                </td>
                                <td width="86">
                                    <p>&nbsp;</p>
                                    <p>❌ Paused (&ldquo;tolled&rdquo;) during offer + 30 days</p>
                                </td>
                                <td width="150">
                                    <p>Taxpayers with limited income/assets who want a permanent reduction in total debt.</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p>&nbsp;</p>
                </div>
            </div>
        )
    }

}

export default InstallmentAgreementGuide;